import {Link} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function PharmMenu(){

const MenuCard = ({link,title,icon,color}) => (

<div className="col-xl-3 col-lg-4 col-md-6 mb-4">
<Link to={link} className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</Link>
</div>

)

return(

<section className="container-fluid mt-4">

<h5 className="menu-section-title">Pharma Billing</h5>

<div className="row">

<MenuCard link="/drug-view" title="OP/IP/Indent Billing" icon="fa-solid fa-capsules" color="#0d6efd"/>
<MenuCard link="/pharm-collection-all?type=salesreturn" title="Sales Return" icon="fa-solid fa-rotate-left" color="#20c997"/>
<MenuCard link="/raise-indent" title="Raise Indent" icon="fa-solid fa-file-circle-plus" color="#6f42c1"/>
<MenuCard link="/indent-drug-list" title="View Indent" icon="fa-solid fa-list" color="#fd7e14"/>
<MenuCard link="/internal-return" title="Internal Return" icon="fa-solid fa-arrow-rotate-left" color="#dc3545"/>
<MenuCard link="/ot-drug-list?type=ot" title="OT Billing" icon="fa-solid fa-scissors" color="#0dcaf0"/>
<MenuCard link="/ot-drug-list?type=ip" title="IP Billing" icon="fa-solid fa-bed" color="#198754"/>

</div>

<h5 className="menu-section-title">Pharmacy Master</h5>

<div className="row">

<MenuCard link="/add-manufacturer" title="Add Manufacturer" icon="fa-solid fa-industry" color="#0d6efd"/>
<MenuCard link="/add-distributor" title="Add Distributor" icon="fa-solid fa-truck" color="#20c997"/>
<MenuCard link="/drug-list" title="Drug List" icon="fa-solid fa-pills" color="#6f42c1"/>
<MenuCard link="/drug-generic" title="Drug Generic" icon="fa-solid fa-flask" color="#fd7e14"/>
<MenuCard link="/add-new-product" title="New Drug Entry" icon="fa-solid fa-capsules" color="#dc3545"/>

</div>

<h5 className="menu-section-title">Pharmacy Reports</h5>

<div className="row">

<MenuCard link="/pharm-collection-all" title="Daily Sales Report" icon="fa-solid fa-chart-line"/>
<MenuCard link="/sale-return-report" title="Sales Return Report" icon="fa-solid fa-rotate-left"/>
<MenuCard link="/detail-sales" title="Detailed Sales Report" icon="fa-solid fa-file-lines"/>
<MenuCard link="/sales-gst-report" title="Sales GST Report" icon="fa-solid fa-file-invoice-dollar"/>
<MenuCard link="/sales-gst-stat" title="Sales GST Statement" icon="fa-solid fa-chart-pie"/>
<MenuCard link="/di-report" title="DI Report" icon="fa-solid fa-file-waveform"/>
<MenuCard link="/schedule-report" title="Schedule Report" icon="fa-solid fa-calendar-days"/>
<MenuCard link="/drug-flow" title="Drug Flow Report" icon="fa-solid fa-arrows-rotate"/>
<MenuCard link="/pat-drug-flow" title="Patient Flow Report" icon="fa-solid fa-users"/>
<MenuCard link="/closing-statement" title="Closing Statement" icon="fa-solid fa-file-circle-check"/>
<MenuCard link="/abc-analysis" title="ABC Analysis" icon="fa-solid fa-chart-area"/>
<MenuCard link="/daily-consolidate" title="Daily Consolidate" icon="fa-solid fa-layer-group"/>
<MenuCard link="/pharm-profit" title="Profit Statement" icon="fa-solid fa-indian-rupee-sign"/>

</div>

</section>

)

}

export default PharmMenu;